import CryptoJS from "crypto-js";

export function encodeScript(str) {
    var encoded = "";
    str = btoa(str);
    str = btoa(str);
    for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ 10; // bitwise XOR with any number, e.g. 123
        encoded = encoded + String.fromCharCode(b);
    }
    encoded = btoa(encoded);
    return encoded;
}
export function decodeScript(encoded) {
    // Giải mã base64 lần đầu tiên
    encoded = atob(encoded);

    // Giải mã XOR
    var decoded = "";
    for (var i = 0; i < encoded.length; i++) {
        var b = encoded.charCodeAt(i);
        var a = b ^ 10; // dùng lại số XOR đã dùng trong encodeScript
        decoded += String.fromCharCode(a);
    }

    // Giải mã base64 hai lần để lấy chuỗi gốc
    decoded = atob(decoded);
    decoded = atob(decoded);

    return decoded;
}

export function encryptJS(text, passKey) {
    var CryptoJS = require("crypto-js");
    var encrypted = CryptoJS.AES.encrypt(text, passKey).toString();
    return encrypted;
}

export function decryptJS(text, passKey) {
    var CryptoJS = require("crypto-js");
    var decrypted = CryptoJS.AES.decrypt(text, passKey).toString(CryptoJS.enc.Utf8);
    return decrypted;
}
/////////////////////////////
////////////////////////////////
/////mã hóa du liệu object khi fetch len luu vao localStorage

//const SECRET_KEY = "jH@05GzMcT$6!"; // 🔑 Khóa bí mật (KHÔNG chia sẻ)
const SECRET_KEY = global.config.key.encrypt;

/// 🔐 **Mã hóa JSON trước khi lưu vào localStorage**
export const encryptData = (data) => {
    try {
        const jsonData = JSON.stringify(data); // Chuyển JSON thành chuỗi
        return CryptoJS.AES.encrypt(jsonData, SECRET_KEY).toString();
    } catch (error) {
        //console.error("❌ Lỗi khi mã hóa:", error);
        return null;
    }
};

/// 🔓 **Giải mã JSON từ localStorage**
export const decryptData = (cipherText) => {
    try {
        const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedText); // Chuyển chuỗi thành JSON
    } catch (error) {
        //console.error("❌ Lỗi khi giải mã:", error);
        return "null";
    }
};

/// 💾 **Lưu vào localStorage**
export const saveToStorage = (key, value) => {
    const encryptedValue = encryptData(value);
    if (encryptedValue) {
        localStorage.setItem(key, encryptedValue);
        //console.log(`✅ Dữ liệu đã mã hóa và lưu: ${key}`);
    }
};

/// 🔍 **Lấy từ localStorage**
export const getFromStorage = (key) => {
    const encryptedValue = localStorage.getItem(key);
    if (!encryptedValue) return "null";
    return decryptData(encryptedValue);
};

///Call api to server
const API_BASE_URL = global.config.url.api; // sửa lại nếu khác

export async function fetchWithAuth(url, options = {}, retry = true) {
    const userStr = window.getFromStorage("user-info");
    if (userStr === "null") window.location.href = "/logout";

    const users = JSON.parse(userStr);
    const accessToken = users.token;

    // Gán method mặc định nếu chưa có
    options.method = options.method || "GET";
    // Gộp headers, nhưng KHÔNG ép Content-Type nếu body là FormData
    const isFormData = options.body instanceof FormData;

    // Thêm Authorization header
    options.headers = {
        ...(options.headers || {}),
        "user-id": users.id,
        Authorization: `Bearer ${accessToken}`,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
    };

    const response = await fetch(API_BASE_URL + url, options);

    if (response.status === 401 && retry) {
        console.warn("Token hết hạn hoặc sai thiết bị");
        //window.location.href = "/logout";
    }

    return response;
}

window.encodeScript = encodeScript;
window.encryptJS = encryptJS;
window.decryptJS = decryptJS;
window.saveToStorage = saveToStorage;
window.getFromStorage = getFromStorage;
window.fetchWithAuth = fetchWithAuth;

// // 🛠 **Ví dụ sử dụng**
// const userData = {
//     id: 123,
//     name: "Nguyễn Văn A",
//     email: "nguyenvana@example.com",
//     roles: ["admin", "editor"],
// };

// saveToStorage("user_data", userData); // 🔥 Lưu dữ liệu đã mã hóa

// const retrievedData = getFromStorage("user_data"); // 🔥 Lấy và giải mã dữ liệu
// console.log("🔓 Dữ liệu sau khi giải mã:", retrievedData);
